import { render, staticRenderFns } from "./dataAuthority.vue?vue&type=template&id=c4883f62&scoped=true&"
import script from "./dataAuthority.vue?vue&type=script&lang=js&"
export * from "./dataAuthority.vue?vue&type=script&lang=js&"
import style0 from "./dataAuthority.vue?vue&type=style&index=0&id=c4883f62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4883f62",
  null
  
)

export default component.exports